import { render } from "./addAssets.vue?vue&type=template&id=75ae3ab6&scoped=true"
import script from "./addAssets.vue?vue&type=script&lang=js"
export * from "./addAssets.vue?vue&type=script&lang=js"

import "./addAssets.vue?vue&type=style&index=0&id=75ae3ab6&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75ae3ab6"]])

export default __exports__